import {
  FETCHED_USERS,
  START_FETCHING_USERS
} from '../actionTypes';

import { UserType } from '../../types/AppTypes';

interface InitialState {
  users: UserType[];
  loading: boolean;
  error: any;
  message: any;
  podcast: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  users: [],
  loading: false,
  error: null,
  message: null,
  podcast: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_USERS:
      return {
        ...state,
        users: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_USERS: {
      const { users, error, message } = action.payload;
      return {
        ...state,
        users,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
